import { mapRecord } from "@base/util/TypeUtil";
import { MaterialGroup, MaterialType, PoleMountType } from "@biz/definitions/SunSailDefinitions";

export interface IPoleMountInfoDef {
  mountAngle?: number;
  validMaterialGroups: (MaterialGroup | MaterialType)[];
  material: MaterialType;
}

export interface IPoleMountInfo {
  poleMountType: PoleMountType
  mountAngle?: number;
  validMaterialGroups: (MaterialGroup | MaterialType)[];
  material: MaterialType;
}

// getGroundSleeveArticle
export const groundSleeveInfos = {
  "00E13000144": { mountAngle: 10, validMaterialGroups: ["steel"], material: "Alu" },
  "00E13000244": { mountAngle: 10, validMaterialGroups: ["alu", "profile", "telescope"], material: "Alu" },
  "00E13001970": { mountAngle: 5, validMaterialGroups: ["alu", "profile", "telescope"], material: "Alu" },
  "60004A001": { mountAngle: 5, validMaterialGroups: ["iron48"], material: "Alu" },
} satisfies Record<string, IPoleMountInfoDef>

export const earthScrewInfos = {
  "00E13000227": { validMaterialGroups: ["alu", "profile", "telescope", "iron48"], material: "Alu" }, // 1400
  "00E13000228": { validMaterialGroups: ["alu", "profile", "telescope", "iron48"], material: "Alu" }, // 1600
  "00E13000756": { validMaterialGroups: ["alu", "profile", "telescope", "iron48"], material: "Alu" } // 114
} satisfies Record<string, IPoleMountInfoDef>

const groundPlateArticles = {
  "00E13001604": { mountAngle: 10, validMaterialGroups: ["Alu"], material: "Alu" },
  "00E13001606": { mountAngle: 0, validMaterialGroups: ["Alu",], material: "Alu" },
  "00E13001653": { mountAngle: 10, validMaterialGroups: ["Alu_Black"], material: "Alu_Black" },
  "00E13001661": { mountAngle: 0, validMaterialGroups: ["Alu_Black"], material: "Alu_Black" },
  "00E13000501": { mountAngle: 5, validMaterialGroups: ["alu"], material: "Alu" },
  "00E13001782": { validMaterialGroups: ["Steel_V4A"], material: "Alu" },
  "00E13000102": { validMaterialGroups: ["Steel"], material: "Alu" },
  "00E13001659": { mountAngle: 10, validMaterialGroups: ["Iron89"], material: "Alu" },
  "00E13001660": { mountAngle: 10, validMaterialGroups: ["Iron89_Black"], material: "Alu_Black" },
  "00E13001649": { mountAngle: 5, validMaterialGroups: ["profile"], material: "Alu" },
  "00E13001870": { mountAngle: 10, validMaterialGroups: ["droppole"], material: "Alu" },
  "00E13001872": { mountAngle: 2, validMaterialGroups: ["droppole"], material: "Alu" },
} satisfies Record<string, IPoleMountInfoDef>

const poleMountArticles = {
  ...mapRecord(groundPlateArticles, (article): IPoleMountInfo => ({ ...article, poleMountType: PoleMountType.GroundPlate })),
  ...mapRecord(earthScrewInfos, (article): IPoleMountInfo => ({ ...article, poleMountType: PoleMountType.EarthScrew })),
  ...mapRecord(groundSleeveInfos, (article): IPoleMountInfo => ({ ...article, poleMountType: PoleMountType.GroundSleeve })),
}
export type PoleMountArticle = keyof typeof poleMountArticles;

export function getPoleMountArticleInfo(article: PoleMountArticle): IPoleMountInfo | undefined {
  return poleMountArticles[article];
}